import React from 'react';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { getVideoFileSource } from './utils';

/**
 * View video content block - uses content's URL field
 * @class View
 * @extends Component
 */
const View = (props) => {
  const { data, className, properties } = props;

  const contentUrl = properties?.url || '';
  const fileSource = getVideoFileSource(properties?.file);
  const buildVideoUrl = (source, file) => {
    if (!source) return null;
    if (source.startsWith('data:video/')) return source;
    if (!file?.filename) return null;
    return `${source}/${file.filename}`;
  };
  const contentFileUrl = buildVideoUrl(fileSource, properties?.file);
  const resolvedUrl = contentUrl || contentFileUrl;

  if (!resolvedUrl) {
    return null;
  }

  return (
    <div
      className={cx(
        'block video align videocontent',
        {
          center: !Boolean(data.align),
        },
        data.align,
        className,
      )}
    >
      <Body data={{ ...data, url: resolvedUrl }} />
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  properties: PropTypes.objectOf(PropTypes.any),
};

export default withBlockExtensions(View);
